import './App.css';
import Maintenance from "./components/Maintenance";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Maintenance/>
      </header>
    </div>
  );
}

export default App;
